/* eslint-disable spellcheck/spell-checker */
/* eslint-disable @typescript-eslint/no-magic-numbers */
import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-loader',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './loader.component.html',
    styleUrl: './loader.component.scss'
})
export class LoaderComponent implements OnChanges {
    @Input()
    remainingAmount!: number;

    @Input()
    color!: string;

    @Input()
    showNumber!: boolean;

    @Input()
    number = 0;

    protected pathData = '';

    protected readonly centerX = 50;
    protected readonly centerY = 50;
    protected readonly radius = 45;

    protected defineArc = this.makeDefineArcFunction(this.centerX, this.centerY, this.radius, 0);

    ngOnChanges(changes: Partial<SimpleChanges>): void {
        if (changes.remainingAmount) {
            this.pathData = this.defineArc(this.remainingAmount);
        }
    }

    // Generate an arced path
    // https://stackoverflow.com/a/18473154
    private makeDefineArcFunction(x: number, y: number, radius: number, startAngle: number): (endAngle: number) => string {
        return (endAngle: number): string => {
            if (startAngle === endAngle) {
                return '';
            }

            const start = this.polarToCartesian(x, y, radius, endAngle);
            const end = this.polarToCartesian(x, y, radius, startAngle);

            const largeArcFlag = endAngle - startAngle <= 180 ? '0' : '1';

            return ['M', start.x, start.y, 'A', radius, radius, 0, largeArcFlag, 0, end.x, end.y].join(' ');
        };
    }

    private polarToCartesian(centerX: number, centerY: number, radius: number, angleInDegrees: number): { x: number; y: number } {
        const angleInRadians = ((angleInDegrees - 90) * Math.PI) / 180.0;

        return {
            x: centerX + radius * Math.cos(angleInRadians),
            y: centerY + radius * Math.sin(angleInRadians)
        };
    }
}
